{
  "legalConfirmLabel": "閉じる",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "プライバシーポリシー",
  "legalTermsOfUse": "利用条件",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_jp",
  "profileLegalNoticesMenuItem": "法律上の注意"
}
